import { TitleCasePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { Dialog } from 'primeng/dialog';
import { DialogService } from 'primeng/dynamicdialog';
import { lastValueFrom, map, Subscription as Subscrivable } from 'rxjs';
import { OpenControllerService, Subscription } from './admin-api';
import { DialogOptions } from './models';
import { StorageService } from './services/auth/storage.service';
import { LoaderService } from './services/loader.service';
import { BroadcastUtil } from './utils/broadcast.util';
import { FormUtil } from './utils/form.util';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DialogService],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChildren(Dialog)
  dialogRefs: QueryList<Dialog>;

  loader = false;
  dialog: DialogOptions | undefined;
  goBack = false;
  menuExpanded = true;
  permissionDenied = false;
  back = false;
  sessionExpired = false;
  progressDialog = false;
  progress: number;
  progressTitle: string;
  public static subscriptions: Subscription[];
  subscriptionsActive: Subscrivable[] = [];

  constructor(
    private cdRef: ChangeDetectorRef,
    private permissionsService: NgxPermissionsService,
    private dialogService: DialogService,
    private openService: OpenControllerService,
    private titleCasePipe: TitleCasePipe
  ) {
    this.permissionsService.loadPermissions(StorageService.userRolesList || []);
    LoaderService.progressSubscriber.subscribe((show: boolean) => {
      this.loader = show;
      this.cdRef.detectChanges();
    });
    this.subscriptionsActive.push(
      BroadcastUtil.get('userChanged').subscribe(async () => {
        this.permissionsService.loadPermissions(
          StorageService.userRolesList || []
        );
      })
    );
    this.subscriptionsActive.push(
      BroadcastUtil.get('dialog').subscribe(
        (result: { options: DialogOptions; goBack: boolean }) => {
          this.dialog = result.options;
          this.goBack = result.goBack;
          this.cdRef.detectChanges();
        }
      )
    );
    this.subscriptionsActive.push(
      BroadcastUtil.get('permissionDenied').subscribe(() => {
        if (!this.sessionExpired) {
          if (!this.permissionDenied) {
            if (this.dialogService.dialogComponentRefMap.size)
              this.dialogService.dialogComponentRefMap.forEach((r) =>
                r.destroy()
              );
            if (document.getElementsByTagName('p-dynamicdialog')?.length) {
              const dialogs = document.getElementsByTagName('p-dynamicdialog');
              for (let index = 0; index < dialogs.length; index++) {
                dialogs[index].remove();
              }
            }
          }
          this.permissionDenied = true;
        }
      })
    );
    this.subscriptionsActive.push(
      BroadcastUtil.get('tokenExpired').subscribe(() => {
        if (!this.sessionExpired)
          if (this.dialogService.dialogComponentRefMap.size)
            this.dialogService.dialogComponentRefMap.forEach((r) =>
              r.destroy()
            );
        this.sessionExpired = true;
      })
    );
    this.subscriptionsActive.push(
      BroadcastUtil.get('progressBar').subscribe(
        (data: { progress: number; title?: string }) => {
          if (data.progress >= 0 && data.progress < 100) {
            this.progress = data.progress;
            this.progressTitle = data.title || 'Carregando...';
            this.progressDialog = true;
          } else {
            this.progressDialog = false;
            this.progressTitle = undefined;
            this.progress = undefined;
          }
          this.cdRef.detectChanges();
        }
      )
    );
  }

  async ngOnInit() {
    if (!StorageService!.subscriptions?.length)
      try {
        StorageService.subscriptions =
          (await lastValueFrom(
            this.openService.findSubscriptionList().pipe(
              map((data) => {
                data.result.sort((a, b) =>
                  FormUtil.semAcento(a.subscriptionName).localeCompare(
                    FormUtil.semAcento(b.subscriptionName)
                  )
                );
                return data.result
                  .map((s) => ({
                    ...s,
                    subscriptionName: this.titleCasePipe.transform(
                      s.subscriptionName
                    )
                  }))
                  .filter((s) => s.subscriptionId);
              })
            )
          )) || [];
      } catch (error) {
        console.error(error);
      }
    AppComponent.subscriptions = StorageService!.subscriptions || [];
  }

  ngOnDestroy(): void {
    this.subscriptionsActive?.forEach((s) => s.unsubscribe());
  }

  goBackHistory(): void {
    if (this.dialog?.visible) this.dialog.visible = false;
    if (window.history.length && window.history.length > 1)
      window.history.back();
    else window.close();
  }

  backFromPermission(): void {
    if (this.permissionDenied) this.permissionDenied = false;
  }

  menuStateChanged($event: boolean): void {
    this.menuExpanded = $event;
    this.cdRef.detectChanges();
  }

  login(): void {
    if (this.sessionExpired) this.sessionExpired = false;
    window.location.reload();
  }

  get userId(): number {
    return StorageService.userId;
  }

  get noLayout(): boolean {
    return window.location.pathname.split('/')[1].includes('home');
  }

  get ready() {
    return AppComponent.subscriptions !== undefined;
  }
}
